<template>
  <div class="jobs">
    <!-- <div class="jobsComcontainer crumbs"><router-link to="/">Home</router-link> &gt; JOBS</div> -->
    <div class="jobsComcontainer job-wrap">
      <h3>很遗憾，目前没有新的招聘信息。</h3>
    </div>
  </div>
</template>

<script>
export default {
  name: "jobs",
  data() {
    return {
      msg: "jobs",
    };
  },
};
</script>


<style scoped lang="scss">
.jobs {
  background: #f3f4f5;
}

.jobsComcontainer {
  width: 1280px;
  margin: 0 auto;
}
.crumbs {
  // margin-top: 67px;
  padding: 17px 0 27px;
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #999;
  display: block;
  a {
    color: #999;
  }
}
.job-wrap {
  font-size: 16px;
  line-height: 1.8em;
  padding: 0px 0px 117px 0px;
  margin-top: 30px;
  h3 {
    font-size: 24px;
    color: #333;
  }
}
@media screen and (max-width: 900px) {
  .job-wrap{padding: 0 2% 117px;}
}
</style>



// WEBPACK FOOTER //
// src/page/Jobs.vue